import type { PackageManager } from '@cli-types/core-engine/utils.js'

export function buildAddDependencyArgs(
  pm: PackageManager,
  dependency: string,
  dev: boolean
): string[] {
  const devFlag = dev ? (pm === 'yarn' ? '--dev' : '-D') : ''

  switch (pm) {
    case 'pnpm':
    case 'yarn':
    case 'bun':
      return ['add', ...(devFlag ? [devFlag] : []), dependency]
    default:
      return ['install', ...(devFlag ? [devFlag] : []), dependency]
  }
}
